// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "ebb96213ae9432a1b3005da771bb7e3f" + ".js";
};